import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import payrollimg from "assets/images/payroll.png";
import attendance from "assets/images/attendance.png";
import hiringimg from "assets/images/hiringimg.png";
import skillsReport from "assets/images/skillsReport.png";
import performance from "assets/images/performance.png";
import departmentPerformance from "assets/images/departmentPerformance.png";
import report from "assets/images/report.png";
import leave from "assets/images/leave.png";
import { useNavigate } from "react-router-dom";
import { Card, Row, Col } from "antd";
import "Common/global.scss";
import Footer from "Common/Footer";

const cardData = [
  { img: payrollimg, text: "Expense Management", onClick: "/expenseManagement" },
  { img: attendance, text: "Attendance", onClick: "/attendance-report" },
  { img: leave, text: "Employees On Leave", onClick: "/leave-report" },
  { img: hiringimg, text: "Hiring", onClick: "/specRecruitment" },
  { img: skillsReport, text: "Skills Report", onClick: "/skillsReport" },
  { img: performance, text: "Employees Performance Review", onClick: "/performance" },
   { img: departmentPerformance, text: "Department Performance Review", onClick: "/department-performance" }
];

// Mapping the premium gradient classes from your global styles
const docCardClasses = [
  "doc-card-1",
  "doc-card-2",
  "doc-card-3",
  "doc-card-4",
  "doc-card-5",
  "doc-card-6",
  "doc-card-7",
  "doc-card-8",
 ];

function Report() {
  const navigate = useNavigate();
  const handleCardClick = (path) => navigate(path);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card title="Self Services" className="card-professional" bordered={false}>
        <div className="document-cards-container">
          <Row gutter={[20, 20]} justify="center">
            {cardData.map(({ img, text, onClick }, index) => {
              // Cycle through the 7 premium gradient classes
              const cardClass = docCardClasses[index % docCardClasses.length];

              return (
                <Col key={index} xs={24} sm={12} md={8} lg={6} xl={4.8}>
                  <div 
                    onClick={() => handleCardClick(onClick)} 
                    style={{ cursor: 'pointer' }}
                  >
                    {/* Replaced circular-box with pro-green-card and doc-card gradient */}
                    <Card className={`pro-green-card ${cardClass}`}>
                      <div className="pro-card-content">
                        <div className="card-icon">
                          <img 
                            src={img} 
                            alt={text} 
                            style={{ 
                              height: "50px", 
                              filter: "brightness(0) invert(1)", // Makes icons white for dark gradients
                              marginBottom: "10px" 
                            }} 
                          />
                        </div>
                        <h3>{text}</h3>
                      </div>
                    </Card>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </Card>
      <Footer />
    </DashboardLayout>
  );
}

export default Report;